import "./EQMDEditor.css"
import MDEditor from "@uiw/react-md-editor";

export default function EQMDEditor(props) {
  return (
    <MDEditor {...props} />
  )
}